import isNil from "lodash/isNil";
import type { PriceValue } from "../../../misc/price";
import { Price } from "../../../misc/price";

export interface SelectedProductOption {
  readonly id: string | undefined;
  readonly quantity: number;
  readonly price?: PriceValue;
}

function getPrice(
  selectedOption: Omit<SelectedProductOption, "quantity">,
  priceListPrice: PriceValue | undefined,
): PriceValue {
  if (!isNil(selectedOption.price)) {
    return selectedOption.price;
  }
  if (selectedOption.price === null) {
    return "UNAVAILABLE";
  }
  return Price.fromNullable(priceListPrice).value;
}

export function getOptionPrice(
  selectedOption: Omit<SelectedProductOption, "quantity">,
  priceListPrice: PriceValue | undefined,
  exchangeRate: number | undefined,
  margin: number,
): Price {
  const price = new Price(getPrice(selectedOption, priceListPrice));
  if (!price.isPresent()) {
    return price;
  }
  if (!exchangeRate) {
    return Price.invalid;
  }
  if (margin === 0 && exchangeRate === 1) {
    return price;
  }
  return price.withMargin(margin).multiply(exchangeRate).round();
}
